<template>
	<div class="material-notification">
		<transition-group
			enter-active-class="animate__animated animate__fadeInLeft"
			leave-active-class="animate__animated animate__bounceOutRight"
		>
			<component
				:is="notification.component"
				v-for="(notification, key) in notifications"
				:key="notification.id"
				:data="notification.data"
				class="material-notification__item"
				@notify-remove="remove(key)"
			/>
		</transition-group>
	</div>
</template>

<script>
import NotificationAlert from "lib/components/NotificationAlert";
import NotificationInfo from "lib/components/NotificationInfo";

export default {
	name: "Notification",
	components: {
		NotificationAlert,
		NotificationInfo
	},
	data() {
		return {
			notifications: []
		};
	},
	created() {
		this.notificationId = 0;
		$bus.$on("notify", this.show);
	},
	beforeDestroy() {
		$bus.$off("notify", this.show);
	},
	methods: {
		show(component, data=null) {
			this.notifications.push({ id: this.notificationId++, component, data });
		},
		remove(key) {
			this.notifications.splice(key, 1);
		},
		removeAll() {
			this.notifications = [];
		}
	}
};
</script>

<style lang="scss" scoped>
.material-notification {
	display: flex;
	flex-direction: column-reverse;
	align-items: flex-end;
	position: fixed;
	top: 0;
	right: 0;
	left: 0;
	width: auto;
	height: auto;
	z-index: 2147483647;
	span:first-child { /* span in which transition-group is rendered into */
		width: 100%;
	}
	.material-notification__item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		position: relative;
		top: 0;
		width: 100%;
		padding: 12px;
		z-index: 2147483647;
	}
}
</style>
